import React from "react";
import Questionaire from "../../components/Questionaire/Questionaire";
import "./style.css";

const QuizBoard = () => {
  return (
    <>
      <Questionaire />
    </>
  );
};

export default QuizBoard;
